import { render, staticRenderFns } from "./AssociateWineList.vue?vue&type=template&id=366297e2&scoped=true"
import script from "./AssociateWineList.vue?vue&type=script&lang=js"
export * from "./AssociateWineList.vue?vue&type=script&lang=js"
import style0 from "./AssociateWineList.vue?vue&type=style&index=0&id=366297e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366297e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('366297e2')) {
      api.createRecord('366297e2', component.options)
    } else {
      api.reload('366297e2', component.options)
    }
    module.hot.accept("./AssociateWineList.vue?vue&type=template&id=366297e2&scoped=true", function () {
      api.rerender('366297e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/AssociateWine/AssociateWineList.vue"
export default component.exports